module.exports = __webpack_public_path__ + "img/step_3-4.6c6fd47f.png";